import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: ",
        ";\n  position: relative;\n  //height: 100%;\n  gap: 16px;\n  cursor: pointer;\n\n  .book-tag-wrapper {\n    display: flex;\n    gap: 4px;\n  }\n\n  .thumb-container {\n    position: relative;\n  }\n\n  .thumb-wrapper {\n    position: relative;\n    width: 136px;\n    height: 136px;\n    background-color: ",
        ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 6px;\n\n    :hover {\n      transition: all 0.3s ease-in-out;\n      background-color: ",
        ";\n    }\n\n    img {\n      box-shadow: 3px 3px 12px 0px rgba(28, 31, 46, 0.06);\n      border-radius: 2px;\n      //width: 92px;\n    }\n\n    .index-label {\n      position: absolute;\n      left: 0;\n      top: 0;\n      background-color: rgba(169, 175, 199, 0.2);\n      color: ",
        ";\n      text-align: center;\n      font-size: 18px;\n      font-weight: 900;\n      width: 26px;\n      height: 26px;\n      border-radius: 6px 0;\n    }\n  }\n\n  .preview-btn {\n    position: absolute;\n    bottom: 0;\n    border-radius: 4px;\n    border: 1px solid ",
        ";\n    background-color: #fff;\n    color: var(--Gray-gray_500, #6a708a);\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 22px;\n    /* width: 110px; */\n    text-align: center;\n    padding: 4px 12px;\n    cursor: pointer;\n\n    :hover {\n      transition: all 0.3s ease-in-out;\n      background-color: ",
        ";\n    }\n  }\n\n  .contents-wrapper {\n    flex: 1;\n    align-items: flex-start;\n    display: flex;\n    flex-direction: column;\n\n    p {\n      line-height: 1.5;\n      text-align: left;\n    }\n\n    .title {\n      margin-top: 8px;\n      -webkit-line-clamp: 2;\n      white-space: normal;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      display: -webkit-box;\n      -webkit-box-orient: vertical;\n      color: ",
        ";\n    }\n\n    .author {\n      margin-top: 4px;\n      color: ",
        ";\n      font-size: 14px;\n\n      &.non-clickable {\n        pointer-events: none;\n      }\n\n      :hover:not(.non-clickable) {\n        text-decoration: underline;\n      }\n    }\n\n    .price {\n      color: ",
        ";\n      font-size: 20px;\n      font-weight: 700;\n      line-height: 26px;\n      margin-top: 16px;\n      display: flex;\n      align-items: center;\n    }\n  }\n\n  @media (max-width: 768px) {\n    .book-tag-wrapper {\n      gap: 5px;\n    }\n\n    .thumb-wrapper {\n      width: 108px;\n      height: 108px;\n      border-radius: 4px;\n\n      img {\n        width: 56px;\n      }\n\n      .index-label {\n        font-size: 12px;\n        width: 18px;\n        height: 18px;\n        line-height: 1.5;\n      }\n    }\n\n    .contents-wrapper {\n      .title {\n        font-size: 14px;\n      }\n\n      .author {\n        font-size: 14px;\n        line-height: 22px;\n      }\n\n      .price {\n        font-size: 16px;\n        margin-top: 8px;\n\n        > span {\n        }\n      }\n    }\n\n    .preview-btn {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  font-weight: 400;\n  padding: 2px 8px;\n  border-radius: 4px;\n  line-height: 22px;\n  font-size: 14px;\n  @media (max-width: 768px) {\n    font-size: 12px;\n    line-height: 22px;\n    padding: 2px 6px;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  margin-left: 8px;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  bottom: ",
        ";\n  top: ",
        ";\n  left: 8px;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  bottom: ",
        ";\n  top: ",
        ";\n  left: 8px;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { numberFormatter } from "@/lib/utils";
import { useRouter } from "next/router";
import { useMemo } from "react";
import styled from "styled-components";
import { CouponTag, EditableTag, OnlySolvookTag } from "@/components/Tags";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { Subjects } from "../../api/product";
import { useMainPageStore } from "../../store/main";
import { usePreviewDialogStore } from "../Search/PreviewDialogProvider";
// import Image from '../common/Image'
import { DEFAULT_BOOK_COVER } from "@/settings/constant";
import Image from "next/image";
import RatingWithText from "../common/RatingWithText";
//과목이 사회 과학인 경우 단원태그를 보여주지 않음
const HIDDEN_UNIT = [
    Subjects.SC,
    Subjects.SO
];
export const BookCard = (param)=>{
    let { book , index , positionType , onClick , mixpanelPosition ="쏠북메인"  } = param;
    const { openPreviewDialog  } = usePreviewDialogStore();
    const router = useRouter();
    const subject = (book === null || book === void 0 ? void 0 : book.subject) || useMainPageStore((state)=>state.subject);
    //과목이 수학일 경우 단원태그만 보여줌
    const isMath = useMemo(()=>subject === "MA", [
        subject
    ]);
    const onClickPreviewBtn = async (e)=>{
        openPreviewDialog({
            id: book.id.toString()
        });
        mixpanelEvent("Preview Button Clicked", {
            bookId: book.id,
            bookTitle: book.title,
            Proposition: mixpanelPosition
        });
    };
    const goToProductDetail = (id)=>{
        router.push("/products/".concat(id));
        onClick && onClick();
    };
    var _book_imageUrl;
    return /*#__PURE__*/ _jsxs(BookInfoWrapper, {
        positiontype: positionType,
        className: "book-info-wrapper",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "thumb-container",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "thumb-wrapper",
                        onClick: ()=>goToProductDetail(book.id),
                        children: [
                            positionType === "selectedBook" && /*#__PURE__*/ _jsx("span", {
                                className: "index-label",
                                children: index + 1
                            }),
                            /*#__PURE__*/ _jsx(Image, {
                                src: (_book_imageUrl = book.imageUrl) !== null && _book_imageUrl !== void 0 ? _book_imageUrl : DEFAULT_BOOK_COVER,
                                width: 100,
                                height: 100,
                                alt: "selected-book-image"
                            }),
                            (book === null || book === void 0 ? void 0 : book.isEditable) && /*#__PURE__*/ _jsx(BookCardEditableTag, {
                                positionType: positionType,
                                children: "편집가능"
                            }),
                            (book === null || book === void 0 ? void 0 : book.badgeText) && /*#__PURE__*/ _jsx(BookOnlySolvookTag, {
                                positionType: positionType,
                                children: book.badgeText
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "preview-btn",
                        onClick: ()=>onClickPreviewBtn(book.id),
                        children: "샘플 보기"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "contents-wrapper",
                onClick: ()=>goToProductDetail(book.id),
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "book-tag-wrapper",
                        children: [
                            !HIDDEN_UNIT.includes(subject) && book.unit && /*#__PURE__*/ _jsx(BookTag, {
                                tagType: "primary",
                                children: book.unit
                            }),
                            !isMath && book.category.tag && /*#__PURE__*/ _jsx(BookTag, {
                                tagType: "default",
                                children: book.category.tag
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "title",
                        children: book.title
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "author ".concat(!book.brandName && "non-clickable"),
                        onClick: (e)=>{
                            e.stopPropagation();
                            router.push("/@".concat(book.brandName));
                        },
                        children: book.author
                    }),
                    /*#__PURE__*/ _jsxs("p", {
                        className: "price",
                        children: [
                            typeof book.price === "number" ? "".concat(numberFormatter(book.price), "원") : book.price,
                            (book === null || book === void 0 ? void 0 : book.isCouponAvailable) && /*#__PURE__*/ _jsx(BookCardCouponTag, {
                                children: "할인쿠폰"
                            })
                        ]
                    }),
                    book.rating && book.rating >= 3 && /*#__PURE__*/ _jsx(RatingWithText, {
                        rating: book.rating
                    })
                ]
            })
        ]
    });
};
const BookInfoWrapper = styled.div.withConfig({
    componentId: "sc-7b194a99-0"
})(_templateObject(), (props)=>props.positiontype === "selectedBook" ? "row" : "column", (props)=>props.theme.new.colors.sol_gray_0, (props)=>props.theme.new.colors.sol_gray_50, (props)=>props.theme.new.colors.sol_gray_500, (props)=>props.theme.new.colors.sol_gray_200, (props)=>props.theme.new.colors.sol_gray_50, (props)=>props.theme.new.colors.sol_gray_700, (props)=>props.theme.new.colors.sol_gray_500, (props)=>props.theme.new.colors.sol_gray_800);
const BookTag = styled.div.withConfig({
    componentId: "sc-7b194a99-1"
})(_templateObject1(), (props)=>props.tagType === "primary" ? props.theme.new.colors.sol_indigo_0 : props.theme.new.colors.sol_gray_0, (props)=>props.tagType === "primary" ? props.theme.new.colors.sol_indigo_500 : props.theme.new.colors.sol_gray_500);
const BookCardCouponTag = styled(CouponTag).withConfig({
    componentId: "sc-7b194a99-2"
})(_templateObject2());
const BookCardEditableTag = styled(EditableTag).withConfig({
    componentId: "sc-7b194a99-3"
})(_templateObject3(), (props)=>props.positionType === "selectedBook" && "8px", (props)=>props.positionType === "curation" && "8px");
const BookOnlySolvookTag = styled(OnlySolvookTag).withConfig({
    componentId: "sc-7b194a99-4"
})(_templateObject4(), (props)=>props.positionType === "selectedBook" && "8px", (props)=>props.positionType === "curation" && "8px");
